        import { WebErrorCodes } from "../../../../../../../utProto/webEnums_pb";

export enum PlanActions {
    DOWNGRADE = 'Subscribe Plan',
    UPGRADE = 'Upgrade Plan',
    REDEEMED = 'Offer Redeemed',
    APPLY = 'Apply Now',
    SUBSCRIBE = 'Subscribe Plan',
    PENDING = 'Under Process'
}

export enum PlanSubscription {
    INACTIVE = 'INACTIVE',
    ACTIVE = 'ACTIVE',
    CANCELLED = 'CANCELLED',
    PENDING = 'PENDING'
}

export enum ApplicationStatus {
    APPROVED = 'approved',
    DECLINED = 'declined',
    SUSPENDED = 'suspended'
}

export enum ApplicationStatusMessage {
    approved = 'You can now proceed to subscribe and unlock exclusive benefits tailored just for you.',
    declined = 'You can explore other plans or contact support for further assistance.',
    suspended = 'You can continue to enjoy the features until the current subscription expires.'
}

export enum ApplicationStatusButtonText {
    approved = 'Subscribe Now',
    declined = 'Explore Plans',
    suspended = 'Continue'
}

export enum PaymentMode {
    UPI = 'UPI',
    CARD = 'CARD',
    STRIPE = 'STRIPE',
    APPLE_PAY = 'APPLE_PAY',
}

export enum PaymentGateway {
    STRIPE = 'STRIPE',
    HDFC = 'HDFC',
    CHARGEBEE = 'CHARGEBEE'
}

export enum StripeString {
    STRIPE = 'STRIPE'
}

export enum PlanErrorCodes {
    BT_NOT_ALLOWED = WebErrorCodes.WEBERRORCODES_BACKTESTINGNOTALLOWED,
    LIVE_NOT_ALLOWED = WebErrorCodes.WEBERRORCODES_LIVTRADINGNOTALLOWED,
    EXTERNAL_NOT_ALLOWED = WebErrorCodes.WEBERRORCODES_EXTERNALSTRATEGYNOTALLOWED,
    ORIGINALS_NOT_ALLOWED = WebErrorCodes.WEBERRORCODES_UTRADEORIGINALSNOTALLOWED,
    FORWARD_TESTING_NOT_ALLOWED = WebErrorCodes.WEBERRORCODES_FORWARDTESTINGNOTALLOWED
}

export const PORTFOLIO_PLAN_ERROR_CODES: number[] = [
    WebErrorCodes.WEBERRORCODES_BACKTESTINGNOTALLOWED,
    WebErrorCodes.WEBERRORCODES_LIVTRADINGNOTALLOWED,
    WebErrorCodes.WEBERRORCODES_PORTFOLIOCREATIONNOTALLOWED,
    WebErrorCodes.WEBERRORCODES_MAXPORTFOLIOLIMITBREACHED,
    WebErrorCodes.WEBERRORCODES_EXTERNALSTRATEGYNOTALLOWED,
    WebErrorCodes.WEBERRORCODES_MAXACTIVEALGOCOUNTREACHED,
    WebErrorCodes.WEBERRORCODES_UTRADEORIGINALSNOTALLOWED,
    WebErrorCodes.WEBERRORCODES_FORWARDTESTINGNOTALLOWED,
]

export enum TransactionStatus {
    SUCCESS = "SUCCESS",
    FAILED = "FAILED",
    PENDING = "PENDING",
    CANCELLED = "CANCELLED",
    UPDATED = "UPDATED",
    NOTINITIATED = "NOTINITIATED",
}

export enum TransactionType {
    COLLECT_NOW = 'collect_now'
}

export enum DiscountType {
    PERCENTAGE = 'percentage',
    FIXED_AMOUNT = 'fixed_amount'
}

export enum SymbolsSelected {
    All_FO = 'All F&O',
    ALL_EQUITY='All Equity',
    All = 'All',
}

export enum frequencyMappingMultiple{
    "months" = "MONTHLY",
    "days" = "DAILY",
    "years" = "YEARLY",
    "weeks" = "WEEKLY",
}

export enum InhousePlanStatus {
    YES = 'YES',
    NO = 'NO',
    PENDING = 'PENDING',
}